import * as CL from '@design-system/component-library';
import { paths } from '../../../common/constants/pathVariables.js';
import { omaElisaClassicMsg, omaElisaForCompaniesMsg, t } from '../../../common/i18n';
import type { AuthServiceProps } from '../../../public/site/authService.js';
import type * as CLT from '@design-system/component-library';
import type { NavigateFunction } from 'react-router';

export const personalUserMenuLinks = (
  navigate: NavigateFunction,
  classicSiteUrl: string,
  prepareElisaIdLogin?: AuthServiceProps['prepareElisaIdLogin']
): CLT.HeaderUserMenuProps['notifications'] => [
  {
    icon: <CL.Icon icon="office" />,
    onClick: e => {
      e.preventDefault();
      navigate(paths.SELF_SERVICE_HOME);
    },
    text: t.LOUS(omaElisaForCompaniesMsg),
    url: paths.SELF_SERVICE_HOME,
  },
  {
    icon: <CL.Icon icon="external-link" />,
    onClick: () => {},
    text: t.SLBP(omaElisaClassicMsg),
    url: classicSiteUrl,
  },
  ...(prepareElisaIdLogin
    ? [
        {
          icon: <CL.Icon icon="arrow-left" />,
          onClick: (e: React.MouseEvent) => {
            e.preventDefault();
            prepareElisaIdLogin({ changeContext: true });
          },
          text: t.GT6R('Change your role'),
          url: '#',
        },
        {
          icon: <CL.Icon icon="arrow-left" />,
          onClick: (e: React.MouseEvent) => {
            e.preventDefault();
            prepareElisaIdLogin({ noContextClient: true });
          },
          text: t.D1GD('Add new company'),
          url: '#',
        },
      ]
    : []),
];
